import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Map, List } from 'immutable';

import AccountCard from '../components/cards/AccountCard';

import '../styles/ProjectCardsContainer.css';

class AccountCards extends Component {
  static propTypes = {
    accounts: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]).isRequired,
    currentUser: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
    // users: PropTypes.instanceOf(Map).isRequired,
  };

  accounts() {
    const { dispatch, accounts, currentUser } = this.props;

    let accountsArray = [];
    let sortedAccounts = [];

    if (!accounts || !accounts.size) return null;

    accounts.forEach(a => {
      sortedAccounts.push(a);
    });

    sortedAccounts.sort(
      (a, b) => new Date(b.get('created_at')) - new Date(a.get('created_at')),
    );

    sortedAccounts.forEach((v, k) => {
      // const {users} = this.props;
      // const user = users.get(v.get('user')) ? users.get(v.get('user')) : null;
      if (v && v.has('counts')) {
        accountsArray.push(
          <AccountCard
            dispatch={dispatch}
            account={v}
            key={k}
            currentUser={currentUser}
          />,
        );
      }
    });

    return accountsArray;
  }

  render() {
    const accountsList = this.accounts();
    return (
      <div className="row col-xs projects-list">
        {accountsList}
      </div>
    );
  }
}

// function selectAccounts(accounts) {
//   return accounts;
//   return accounts.filter((project, key) => {
//     return project.get('id') > 607 || project.get('id') == 479
//   });
// }

// const accountsSelector = (state) => {
//   return state.accounts.get('accounts');
// }
// const usersSelector = (state) => state.users.get('users');

// const ProjectCardsSelector = createSelector(
//   [accountsSelector, usersSelector],
//   (accounts, users) => {
//     return {
//       accounts: selectAccounts(accounts),
//       users
//     };
//   }
// );

// @connect(ProjectCardsSelector)

export default class AccountCardsContainer extends Component {
  static propTypes = {
    accounts: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]).isRequired,
    currentUser: PropTypes.instanceOf(Map),
    dispatch: PropTypes.func,
  };

  render() {
    const { accounts, dispatch, currentUser } = this.props;
    return (
      <AccountCards
        dispatch={dispatch}
        accounts={accounts}
        currentUser={currentUser}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AccountCardsContainer.js